export const timestampToDate = (timestamp: number | string) => {
    // Convert string to number if needed
    const ts = typeof timestamp === 'string' ? parseInt(timestamp, 10) : timestamp;
  
    // Multiply by 1000 if it's in seconds
    const date = new Date(ts < 1e12 ? ts * 1000 : ts);
  
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    
    return `${month}/${day} ${formattedHours}:${formattedMinutes} ${ampm}`;
  };
  